/* eslint-disable */
document.addEventListener('DOMContentLoaded', function () {
	const toRepaint = document.querySelectorAll('.v2-js-repaint');

	for (let a = 0; a < toRepaint.length; a++) {
		repaint(toRepaint[a]);
	}
});


export function repaint(dom) {
	dom.style.display = 'none';
	dom.offsetHeight;
	dom.style.display = '';
}